
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon",
      function () {
        return require("private-next-pages/lon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon"])
      });
    }
  